export default __webpack_public_path__ + "static/meta-image-c7483bafd50e088536cb5592e520d9bf.jpg";